"use client";

import type { CountryValue } from "@offstreetparking/geography";
import { createContext, useContext } from "react";

export type FlowCompany = {
	id: number;
	name?: string | null;
	country?: CountryValue | null;
	state?: string | null;
	timezone?: string | null;
	isOptionalParkerAccountsEnabled?: boolean | null;
};

export type CompanyContextValue = {
	company?: FlowCompany | null;
	isPending: boolean;
	error?: Error;
	isFromSubdomain: boolean;
};

const CompanyContext = createContext<CompanyContextValue | undefined>(undefined);

export const CompanyStateProvider = ({
	value,
	children,
}: {
	value: CompanyContextValue;
	children: React.ReactNode;
}) => <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>;

export const useCompany = () => {
	const context = useContext(CompanyContext);
	if (context === undefined) {
		throw new Error("useCompany must be used within a CompanyStateProvider");
	}
	return context;
};
